import * as React from 'react';

import { FilterModal } from '../../components/FilterModal';
import { PriceInputsContainer } from '../PriceInputsContainer';

interface IPriceModalContainerProps {
  hideFooter?: boolean;
  onResetClick(): void;
  onApplyClick(): void;
  onClose(): void;
  onMinBlur(): void;
  onMaxBlur(): void;
}

export const PriceModalContainer = React.forwardRef<HTMLDivElement, IPriceModalContainerProps>(
  ({ hideFooter, onResetClick, onApplyClick, onClose, onMinBlur, onMaxBlur }, ref) => {
    return (
      <FilterModal
        ref={ref}
        title="Цена"
        hideFooter={hideFooter}
        onResetClick={onResetClick}
        onApplyClick={onApplyClick}
        onClose={onClose}
      >
        <PriceInputsContainer onMinBlur={onMinBlur} onMaxBlur={onMaxBlur} />
      </FilterModal>
    );
  },
);

PriceModalContainer.displayName = 'PriceModalContainer';
